import { Button, FormInstance } from "antd";
import FormattedCheckboxGroupInput from "top-component-library/form-inputs/FormattedCheckboxGroupInput";

import { computeToggleAll } from "../modalUtils";
import { SelectOption } from "../types";

interface MembershipChecklistSectionProps {
  id: string;
  label: string;
  name: string;
  options: SelectOption[];
  form: FormInstance;
}

// A membership checklist (locations / stations / kds stations / menus) with a "Toggle all"
// button, mirroring the AngularJS toggleAll helper. Selection is stored on the form field
// `name` as an array of ids.
const MembershipChecklistSection = ({ id, label, name, options, form }: MembershipChecklistSectionProps) => {
  const handleToggleAll = () => {
    const current: string[] = form.getFieldValue(name) || [];
    const allIds = options.map((option) => option.value);
    form.setFieldsValue({ [name]: computeToggleAll(current, allIds) });
  };

  return (
    <FormattedCheckboxGroupInput
      id={id}
      label={label}
      name={name}
      options={options}
      required={false}
      onChange={() => {}}
      validationMessage=""
    >
      <Button id={`${id}-toggle-all`} type="link" onClick={handleToggleAll}>
        Toggle all
      </Button>
    </FormattedCheckboxGroupInput>
  );
};

export default MembershipChecklistSection;
